export default __webpack_public_path__ + "static/media/Board Games.44311a2f.svg";